<template>
  <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {scale} from "@/utils/colors";

export default {
  name: "TopProjectsBySavings",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    topProjects: {
      type: Array,
      default: () => ([])
    },
    currencyFormatter: {
      default: null
    }
  },
  data: () => ({
    dataColor: scale(1)
  }),
  methods: {
    async goToProject(id) {
      if (!this.projects[id]) {
        const _id = this.project_options.find(d => d.shortId === id).value;
        await this.$store.dispatch('getProjectDetail', _id);
      }
      this.$router.push({ name: 'ProjectDetail', params: { id } });
      document.querySelector('#main-view').scrollTo(0, 0);
    },
  },
  computed: {
    projects() {
      return this.$store.getters.projects;
    },
    all_projects() {
      return this.$store.getters.all_projects;
    },
    project_options() {
      return Object.keys(this.all_projects)
        .filter(key => key !== this.project_id)
        .map(key => {
          return {
            text: this.all_projects[key].name,
            value: this.all_projects[key].id,
            shortId: this.all_projects[key].shortId,
          };
        });
    },
    chartOptions() {
      return {
        chart: {
          export: {
            csv: {
              headerCategory: 'Projects',
            }
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const { project } = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
              if (project && project.shortId) this.goToProject(project.shortId);
            },
            xAxisLabelClick: (event, chartContext, {config, labelIndex}) => {
              const { project } = config.series[0].data[labelIndex];
              if (project && project.shortId) this.goToProject(project.shortId);
            }
          }
        },
        title: {
          text: 'Top Projects By Savings',
          align: 'center',
          floating: true
        },
        noData: {
          text: 'No Data To Show Yet',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'bottom' // use 'bottom' for left and 'top' for right align
            },
          }
        },
        colors: this.dataColor,
        dataLabels: {
          textAnchor: 'start',
          offsetX: 10,
          formatter: function (val, opt) {
            const {project} = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
            return project ? project.name : ''
          },
          style: {
            colors: ['black']
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Realised', 'Forecasted'],
          markers: {
            fillColors: [this.dataColor, '#775DD0']
          }
        },
        tooltip: {
          x: {
            formatter: (val, opt) => {
              const {project} = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
              return project ? project.name : ''
            }
          },
          y: {
            formatter: (val) => {
              return this.currencyFormatter ? this.currencyFormatter(val) : val;
            }
          }
        },
        xaxis: {
          labels: {
            formatter: (val) => {
              return this.currencyFormatter ? this.currencyFormatter(val) : val;
            },
          }
        },
      }
    },
    series() {
      return [{
        name: 'Realised',
        data: this.topProjects.map((project) => {
          return {
            y: project.amountOrgCurrency,
            x: project.shortId,
            project,
            goals: [
              {
                name: 'Forecasted',
                value: project.forecastedAmountOrgCurrency,
                strokeWidth: 5,
                strokeHeight: 10,
                strokeColor: '#775DD0'
              }
            ]
          }
        })
      }]
    }
  }
}
</script>

<style scoped>

</style>
